import { render, staticRenderFns } from "./ProjectItemQuantity.vue?vue&type=template&id=70b13e41&"
import script from "./ProjectItemQuantity.vue?vue&type=script&lang=js&"
export * from "./ProjectItemQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports